//
// Search Filter
//
// Validates and organises pasting of rs stock numbers into the search filter
// ---------------------------------------------------------------------------

(function ($) {
    'use strict';

    const toggles = $('.js-search-by-toggles input');
    const stockNumbersInput = $('.js-stock-numbers-input');
    const MAXIMUM_ALLOWED_STOCK_NUMBERS = stockNumbersInput.data('maxLimit');

    stockNumbersInput.on('change', updateStockNumbers);
    toggles.on('change', toggleQueryPanel);

    if (toggles.filter(':checked').val() === 'search-by-query') {
        $('.js-search-by-rs-stock-numbers-container').addClass('u-hide');
    } else {
        $('.js-search-by-query-container').addClass('u-hide');
    }

    /**
     * Toggle the state of the query panel based on which checkbox was selected
     */
    function toggleQueryPanel() {
        const container = $(this).closest('.js-search-container');
        const queryContainer = container.find('.js-search-by-query-container');
        const rsStockContainer = container.find('.js-search-by-rs-stock-numbers-container');

        queryContainer.addClass('u-hide');
        rsStockContainer.addClass('u-hide');

        if($(this).val() === 'search-by-query') {
            queryContainer.removeClass('u-hide');
        } else {
            rsStockContainer.removeClass('u-hide');
        }
    }


    /**
     * Update the stock numbers that have been input to carry out tasks such as normalising delimeters,
     * deduping, and truncation to maximum allowed.
     */
    function updateStockNumbers () {
        const input = $(this);
        normaliseStockNumbersDelimiter(input);
        deduplicateStockNumbers(input);

        if (hasExceededStockNumberLimit(input)) {
            truncateStockNumbersToMaximumAllowed(input);
        }
    }

    /**
     * Stock numbers can be delimited in a variety of ways, e.g. by tabs, new-lines (differing by OS), commas, etc.
     *
     * This will normalise the entered stock numbers and delimit them by commas.
     *
     * @param {jQuery} input
     */
    function normaliseStockNumbersDelimiter (input) {
        var currentValue = input.val();

        input.val(
            currentValue
                // Replace tabs with commas
                .replace(/\t/g, ',')

                // Replace new lines with commas
                .replace(/\r\n/g, ',')
                .replace(/\n/g, ',')
                .replace(/\r/g, ',')

                // Remove trailing spaces before and after commas
                .replace(/,( )+/g, ',')
                .replace(/( )+,/g, ',')

                // Remove duplicate commas
                .replace(/,{2,}/g, ',')

                // Remove trailing comma
                .replace(/,$/g, '')

                // Remove commas that have nothing before them
                .replace(/^,+/g, '')
        );
    }

    /**
     * Remove duplicate stock numbers.
     *
     * Note that we only check for exact duplicates, i.e. given the user has input:
     *
     *      ABC 123, ABC 123, ABC-123
     *
     * The output will be:
     *
     *      ABC 123, ABC-123
     *
     * Even though both are conceptually the same stock number.
     *
     * @param {jQuery} input
     */
    function deduplicateStockNumbers (input) {
        const enteredStockNumbers = input.val().split(',');
        const dedupedStockNumbers = [];
        const numberOfStockNunbers = enteredStockNumbers.length;

        for (let i = 0; i < numberOfStockNunbers; i++) {
            let stockNumber = enteredStockNumbers[i];

            if (dedupedStockNumbers.indexOf(stockNumber) === -1) {
                dedupedStockNumbers.push(stockNumber);
            }
        }

        input.val(dedupedStockNumbers.join(','));
    }

    /**
     * A user can enter a potentially infinite amount of stock numbers.
     *
     * To reduce load on the API we truncate this to a maximum number of searchable stock numbers.
     *
     * @param {jQuery} input
     */
    function truncateStockNumbersToMaximumAllowed (input) {
        const stockNumbers = input.val().split(',');

        input.val(stockNumbers.splice(0, MAXIMUM_ALLOWED_STOCK_NUMBERS).join(','));
    }

    /**
     * Check whether the user has enterred more than the maximum allowed number of stock numbers.
     *
     * @param {jQuery} input
     *
     * @returns {boolean}
     */
    function hasExceededStockNumberLimit (input) {
        const stockNumbers = input.val().split(',');

        return stockNumbers.length > MAXIMUM_ALLOWED_STOCK_NUMBERS;
    }
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/components/product-search-filter.js